const awsExports = {
    region: "us-east-2",
    userPoolId: "us-east-2_RXjXg9Zgf",
    userPoolWebClientId: "779gpkckdt46mgqapev2jlnrbf",
    apiGatewayurl: "https://69hg1f28ik.execute-api.us-east-2.amazonaws.com/v0/",
    emailDomain: "emails.baldanzasolutions.com",
};

export default awsExports;